import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-segment',
  templateUrl: './icon-segment.component.html',
  styleUrls: ['./icon-segment.component.scss'],
})
export class IconSegmentComponent {
  constructor() {}
}
